import { createReactComponent } from '@tabler/icons-react';

export const IconCustomSquareLetterECheck = createReactComponent(
  'outline',
  'customSquareLetterECheck',
  'CustomSquareLetterECheck',
  [
    [
      'path',
      {
        key: 'customSquareLetterECheck-path',
        d: 'M14 8H10V16H14M10 12H12.5M21 12V5C21 4.46957 20.7893 3.96086 20.4142 3.58579C20.0391 3.21071 19.5304 3 19 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H12M15.6 18.8L17.6 20.8L21.6 16.8',
      },
    ],
  ]
);
